export default [
  // Verse 2 - 1:52

  {m:57, t: 1, pos: 3, hold: 15}, {m:57, t: 1, pos: 4, hold: 15}, {m:57, t: 1, pos: 5, hold: 15},
  // {m:57, t: 2, pos: 5},
  // {m:57, t: 3, pos: 3},
  // {m:57, t: 4, pos: 3},
  // {m:57, t: 5, pos: 5},
  // {m:57, t: 6, pos: 5},
  // {m:57, t: 7, pos: 3},
  // {m:57, t: 8, pos: 1},

  // m:58 holding until last beat

  {m:59, t: 1, pos: 2, hold: 8}, {m:59, t: 1, pos: 4, hold: 8},
  // {m:59, t: 2, pos: 5},
  // {m:59, t: 3, pos: 3},
  // {m:59, t: 4, pos: 3},
  // {m:59, t: 5, pos: 5},
  // {m:59, t: 6, pos: 5},
  // {m:59, t: 7, pos: 3},
  // {m:59, t: 8, pos: 1},

  {m:60, t: 1, pos: 5},
  {m:60, t: 2, pos: 4, hold: 2},
  // {m:60, t: 3, pos: 3},
  {m:60, t: 4, pos: 2, hold: 4},
  // {m:60, t: 5, pos: 5},
  // {m:60, t: 6, pos: 5},
  // {m:60, t: 7, pos: 3},
  // {m:60, t: 8, pos: 1}, // Off

  {m:61, t: 1, pos: 1, hold: 8}, {m:61, t: 1, pos: 4, hold: 8},
  // {m:61, t: 2, pos: 4},
  // {m:61, t: 3, pos: 3},
  // {m:61, t: 4, pos: 2},
  // {m:61, t: 5, pos: 5},
  // {m:61, t: 6, pos: 5},
  // {m:61, t: 7, pos: 3},
  // {m:61, t: 8, pos: 1},

  {m:62, t: 1, pos: 4},
  {m:62, t: 2, pos: 2},
  {m:62, t: 3, pos: 1},
  {m:62, t: 4, pos: 4, hold: 2},
  // {m:62, t: 5, pos: 5},
  {m:62, t: 6, pos: 3},
  {m:62, t: 7, pos: 2},
  {m:62, t: 8, pos: 3},

  {m:63, t: 1, pos: 1},
  {m:63, t: 2, pos: 3},
  {m:63, t: 3, pos: 1},
  {m:63, t: 4, pos: 2, hold: 13},
  // {m:63, t: 5, pos: 5},
  // {m:63, t: 6, pos: 3},
  // {m:63, t: 7, pos: 2},
  // {m:63, t: 8, pos: 3},

  // m64 holding

  {m:65, t: 1, pos: 4},
  {m:65, t: 2, pos: 3},
  {m:65, t: 3, pos: 2},
  {m:65, t: 4, pos: 4, hold: 2},
  // {m:65, t: 5, pos: 5},
  {m:65, t: 6, pos: 3},
  {m:65, t: 7, pos: 2},
  {m:65, t: 8, pos: 5, hold: 2},

  // {m:66, t: 1, pos: 4},
  {m:66, t: 2, pos: 4},
  {m:66, t: 3, pos: 2},
  {m:66, t: 4, pos: 3},
  {m:66, t: 5, pos: 5},
  {m:66, t: 6, pos: 4},
  {m:66, t: 7, pos: 3},
  {m:66, t: 8, pos: 2},

  {m:67, t: 1, pos: 1, hold: 2},
  // {m:67, t: 2, pos: 4},
  {m:67, t: 3, pos: 2},
  {m:67, t: 4, pos: 3, hold: 2},
  // {m:67, t: 5, pos: 5},
  {m:67, t: 6, pos: 2},
  {m:67, t: 7, pos: 1},
  {m:67, t: 8, pos: 3, hold: 2},

  // {m:68, t: 1, pos: 1},
  {m:68, t: 2, pos: 2, hold: 2},
  // {m:68, t: 3, pos: 2},
  {m:68, t: 4, pos: 3, hold: 2},
  // {m:68, t: 5, pos: 5},
  {m:68, t: 6, pos: 2},
  {m:68, t: 7, pos: 1},
  {m:68, t: 8, pos: 2},

  {m:69, t: 1, pos: 1},
  {m:69, t: 2, pos: 2},
  {m:69, t: 3, pos: 3},
  {m:69, t: 4, pos: 2},
  {m:69, t: 5, pos: 1},
  {m:69, t: 6, pos: 3},
  {m:69, t: 7, pos: 2},
  {m:69, t: 8, pos: 1},

  {m:70, t: 1, pos: 4},
  {m:70, t: 2, pos: 3},
  {m:70, t: 3, pos: 1},
  {m:70, t: 4, pos: 3, hold: 2},
  // {m:70, t: 5, pos: 1},
  {m:70, t: 6, pos: 2},
  {m:70, t: 7, pos: 1},
  {m:70, t: 8, pos: 2},

  {m:71, t: 1, pos: 4},
  {m:71, t: 2, pos: 2},
  {m:71, t: 3, pos: 2},
  {m:71, t: 4, pos: 5, hold: 2},
  // {m:71, t: 5, pos: 1},
  {m:71, t: 6, pos: 3},
  {m:71, t: 7, pos: 2},
  {m:71, t: 8, pos: 4, hold: 2},

  // {m:72, t: 1, pos: 4},
  {m:72, t: 2, pos: 3, hold: 2},
  // {m:72, t: 3, pos: 2},
  {m:72, t: 4, pos: 2},
  {m:72, t: 5, pos: 5},
  {m:72, t: 6, pos: 3, hold: 2},
  // {m:72, t: 7, pos: 2},
  {m:72, t: 8, pos: 2},

];



//////////////////
// WEBPACK FOOTER
// ./lib/songs/song_verse_2.js
// module id = 13
// module chunks = 0